import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { Team } from '../../models/team.model';
import { TeamHelperService } from '../../../my-teams/team-helper.service';
import { IonicModule } from '@ionic/angular';
import { ITA_URL } from '../../../../environments/environment';
import { Tie } from '../../models/tie.model';

@Component({
  selector: 'app-team-profile-image',
  templateUrl: './team-profile-image.component.html',
  styleUrls: ['./team-profile-image.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class TeamProfileImageComponent implements OnInit {
  @Input() team: Team;
  @Input({required: false}) tie: Tie;
  @Input() pageName: string;
  public ITAlogo: string;
  public ths = inject(TeamHelperService);

  ngOnInit() {
     if (this.team && this.team?.organisations && 
      (this.team.organisations[0]?.organisationAbbreviation === 'ITA' || this.tie?.organisations?.some(o => o.organisationAbbreviation === 'ITA'))) {
       this.ITAlogo = `${ITA_URL}/${this.team?.teamId?.toUpperCase()}/Logo`;
    }
  }

  public isAbbreviationShow: boolean = false;

  constructor() { }
}
